<template>
  <div class="c-my-music-list-content-detail-content">
    <div class="c-my-music-list-content-detail-content__content">
      <ul class="content-list" v-if="contentData && contentData.length > 0">
        <draggable class="draggble-wrap" :list="contentData" :sort="detailContentAllowSort" @change="handleSortChange">
          <li class="content-list__item" v-for="(data, idx1) of contentData" :key="data.key">
            <list-detail-content-row :columns="columns" :data="data" :idx1="idx1" />
          </li>
        </draggable>
      </ul>
      <div class="loading-wrap" v-if="isContentLoading">
        <loading />
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, provide, ref, inject } from 'vue';
import { VueDraggableNext as Draggable } from 'vue-draggable-next';
import ListDetailContentRow from '@/components/MyMusic/MyMusicList/ListDetail/ListDetailContentRow.vue';
import useRequest from '@/hooks/useRequest';
import { changeContentSorterAPI } from '@/api/myMusicPlaylists';

const props = defineProps({
  columns: {
    type: Array,
    default: () => [],
  },
  contentData: {
    type: Array,
    default: () => [],
  },
  isContentLoading: {
    type: Boolean,
    default: false,
  },
});

const { request } = useRequest(changeContentSorterAPI);

provide('detailContentData', () => (props.contentData || []));
const reloadPlaylistContent = inject('reloadPlaylistContent');
const detailContentAllowSort = inject('detailContentAllowSort', false);

const handleSortChange = async (val) => {
  console.log('contentData', props.contentData);
  const newSortList = props.contentData.map((item) => item.accountPlaylistContentUid);

  const [err] = await request({
    in: { accountPlaylistContentUids: newSortList },
  });

  if (err) {
    return;
  }

  reloadPlaylistContent();
};
</script>

<style lang="scss" scoped>
.content-list {
  &__item {
    background-color: $c-white3;

    &+& {
      border-top: 1px solid $c-assist7
    }
  }
}

.content-row {
  width: 100%;
  height: 80px;
  @include flex();

  &__item {
    @include flex();

    &__text {
      @include font-style($c-black, 14, normal, 0, 26px);
    }

    &__padding-left {
      padding-left: 20px;
      width: 100%;
    }

    &__checkbox {
      width: 100%;
      @include flex(center);
    }
  }
}

.loading-wrap {
  margin: 15px 0;
  @include flex(center);
}
</style>
